export default __webpack_public_path__ + "static/homepage_footer_background_mobile-bdcb762522a75a69bdeebf1ca6612f8b.png";